/**
 * Flow action constants
 * Centralized action identifiers to prevent magic strings
 */

export const FLOW_ACTIONS = {
    EDIT_FLOW: 'edit-flow',
    EDIT_EMAILS: 'edit-emails',
    PUBLISH: 'publish',
    UNPUBLISH: 'unpublish',
    DUPLICATE: 'duplicate',
    DELETE: 'delete',
} as const;

export type FlowAction = (typeof FLOW_ACTIONS)[keyof typeof FLOW_ACTIONS];
